// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.pendingSection {
  height: calc(100vh - 630px);
  overflow-y: scroll;
  direction: rtl;
  padding-left: 12px;
}
.pendingSection table {
  direction: ltr;
}
.pendingSection table thead tr th {
  font-size: 14px;
  color: rgba(255, 255, 255, 0.7);
  font-family: "Poppins";
  line-height: 19.6px;
  font-weight: 400;
  border-bottom: none;
}
.pendingSection table tbody .row-gap {
  height: 12px;
}
.pendingSection table tbody tr.MuiTableRow-root .teledriverName {
  font-weight: 600;
}
.pendingSection table tbody tr.MuiTableRow-root .taskName {
  width: 150px;
}
.pendingSection table tbody tr.MuiTableRow-root .actionCell button:hover {
  background: none;
}
.pendingSection table tbody tr.MuiTableRow-root .connectivity {
  width: 10%;
  text-align: center;
}
.pendingSection table tbody tr.MuiTableRow-root td {
  border: none;
  margin-bottom: 12px;
  padding: 10px 16px;
  color: rgb(255, 255, 255);
  font-weight: 400;
  font-family: "Poppins";
  font-size: 14px;
  line-height: 22px;
  height: 50px;
}
.pendingSection table tbody tr.MuiTableRow-root td .monitorButton {
  color: #fff;
  font-size: 14px;
  font-family: "Poppins";
  font-weight: 700;
  line-height: 22px;
  text-transform: capitalize;
  padding: 8px 6px;
}
.pendingSection table tbody tr.MuiTableRow-root td .monitorButton .orange {
  color: rgb(255, 139, 30);
}
.pendingSection table tbody tr.MuiTableRow-root td .monitorButton img {
  margin-left: 10px;
}
.pendingSection table tbody tr.MuiTableRow-root td:first-child {
  border-radius: 8px 0px 0px 8px;
  position: relative;
}
.pendingSection table tbody tr.MuiTableRow-root td:first-child img {
  position: absolute;
  left: 0px;
  top: 0px;
}
.pendingSection table tbody tr.MuiTableRow-root td:last-child {
  border-radius: 0px 8px 8px 0px;
  width: 17%;
}`, "",{"version":3,"sources":["webpack://./src/components/Dashboard/RequestsSection/PendingSession/styles.scss"],"names":[],"mappings":"AAAA;EACI,2BAAA;EACA,kBAAA;EACA,cAAA;EACA,kBAAA;AACJ;AACI;EACI,cAAA;AACR;AAGgB;EACI,eAAA;EACA,+BAAA;EACA,sBAAA;EACA,mBAAA;EACA,gBAAA;EACA,mBAAA;AADpB;AAOY;EACI,YAAA;AALhB;AASgB;EACI,gBAAA;AAPpB;AAUgB;EACI,YAAA;AARpB;AAYoB;EACI,gBAAA;AAVxB;AAcgB;EACI,UAAA;EACA,kBAAA;AAZpB;AAegB;EACI,YAAA;EACA,mBAAA;EACA,kBAAA;EACA,yBAAA;EACA,gBAAA;EACA,sBAAA;EACA,eAAA;EACA,iBAAA;EACA,YAAA;AAbpB;AAeoB;EACI,WAAA;EACA,eAAA;EACA,sBAAA;EACA,gBAAA;EACA,iBAAA;EACA,0BAAA;EACA,gBAAA;AAbxB;AAewB;EACI,wBAAA;AAb5B;AAgBwB;EACI,iBAAA;AAd5B;AAmBgB;EACI,8BAAA;EACA,kBAAA;AAjBpB;AAmBoB;EACI,kBAAA;EACA,SAAA;EACA,QAAA;AAjBxB;AAqBgB;EACI,8BAAA;EACA,UAAA;AAnBpB","sourcesContent":[".pendingSection {\r\n    height: calc(100vh - 630px);\r\n    overflow-y: scroll;\r\n    direction: rtl;\r\n    padding-left: 12px;\r\n\r\n    table {\r\n        direction: ltr;\r\n\r\n        thead {\r\n            tr {\r\n                th {\r\n                    font-size: 14px;\r\n                    color: rgba(255, 255, 255, 0.7);\r\n                    font-family: 'Poppins';\r\n                    line-height: 19.6px;\r\n                    font-weight: 400;\r\n                    border-bottom: none;\r\n                }\r\n            }\r\n        }\r\n\r\n        tbody {\r\n            .row-gap {\r\n                height: 12px;\r\n            }\r\n\r\n            tr.MuiTableRow-root {\r\n                .teledriverName {\r\n                    font-weight: 600;\r\n                }\r\n\r\n                .taskName {\r\n                    width: 150px;\r\n                }\r\n\r\n                .actionCell {\r\n                    button:hover {\r\n                        background: none;\r\n                    }\r\n                }\r\n\r\n                .connectivity {\r\n                    width: 10%;\r\n                    text-align: center;\r\n                }\r\n\r\n                td {\r\n                    border: none;\r\n                    margin-bottom: 12px;\r\n                    padding: 10px 16px;\r\n                    color: rgb(255, 255, 255);\r\n                    font-weight: 400;\r\n                    font-family: \"Poppins\";\r\n                    font-size: 14px;\r\n                    line-height: 22px;\r\n                    height: 50px;\r\n\r\n                    .monitorButton {\r\n                        color: #fff;\r\n                        font-size: 14px;\r\n                        font-family: 'Poppins';\r\n                        font-weight: 700;\r\n                        line-height: 22px;\r\n                        text-transform: capitalize;\r\n                        padding: 8px 6px;\r\n\r\n                        .orange {\r\n                            color: rgba(255, 139, 30, 1);\r\n                        }\r\n\r\n                        img {\r\n                            margin-left: 10px;\r\n                        }\r\n                    }\r\n                }\r\n\r\n                td:first-child {\r\n                    border-radius: 8px 0px 0px 8px;\r\n                    position: relative;\r\n\r\n                    img {\r\n                        position: absolute;\r\n                        left: 0px;\r\n                        top: 0px;\r\n                    }\r\n                }\r\n\r\n                td:last-child {\r\n                    border-radius: 0px 8px 8px 0px;\r\n                    width: 17%;\r\n                }\r\n            }\r\n        }\r\n    }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
